<template>
  <login-layout :title="layoutTit">
    <div class="invite-login-tit">
      {{ $t('message["471"]') }} <span>{{ comname }}</span>
    </div>
    <div class="accout-login invite-login">
      <a-form
        :form="form"
        @submit.prevent="submitForm"
      >
        <a-form-item
          label=""
        >
          <a-input
            v-decorator="decorators.mobile"
            :placeholder="mobileTit"
          />
        </a-form-item>
        <a-form-item
          label=""
          class="password-box"
        >
          <a-input
            v-decorator="decorators.checkcode"
            :placeholder="validTit"
            class="password-input"
          />
          <get-code
            class="find-pwd-link"
            :is-disabled="isDisabled"
            type="10"
            :mobile="form.getFieldValue('mobile')"
            @getRes="getRes"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["597"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
import GetCode from '@/components/pc/GetCode.vue'
import { mapActions, mapState } from 'vuex'
import { setAuth } from '@/lib/storage'
export default {
  'name': 'InviteLogin',
  components: {
    LoginLayout,
    GetCode
  },
  data () {
    return {
      isDisabled: false,
      submiting: false,
      inviteLogin: {
        checkuserid: '',
        isreg: 0,
        invitecode: this.$route.query.invitecode // this.$route.query.invitecode || ''
      },
      getCodeUrl2: ''
    }
  },
  computed: {
    ...mapState('organization/inviteJoin', ['decorators']),
    comname () {
      return this.$route.query.comname
    },
    projectname () {
      return this.$route.query.projectname
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    }
    // invitecode () {
    //   return this.$route.query.invitecode
    // }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
  },
  methods: {
    ...mapActions('organization/inviteJoin', ['ajaxJoin', 'ajaxLastJoin']),
    submitForm (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, this.inviteLogin)
          const chain = await this.ajaxJoin()
          chain.params(obj)
            .onSuccess(async (raw, res) => {
              if (!res.error) {
                if (!res.payload.isreg) {
                  this.$router.push({ path: '/organization/invitejoin2', query: { invitecode: this.$route.query.invitecode, mobile: values.mobile, ensecret: res.payload.ensecret } })
                } else {
                  setAuth(res.payload.Authorization)
                  await this.$store.commit('setAuth', res.payload.Authorization, { root: true })
                  const chain = await this.ajaxLastJoin()
                  chain.params({ invitecode: this.$route.query.invitecode })
                    .onSuccess((raw, res) => {
                      if (!res.error) {
                        this.$router.push({ name: 'OrgIndex' })
                      }
                    })
                    .fetch()
                }
              }
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    getRes (payload) {
      this.inviteLogin.checkuserid = payload.checkuserid
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    getCodeValid (from, tel) {
    },
    inputChange () {
      this.isDisabled = false
    }
  }
}
</script>

<style lang="scss" scoped >
.invite-login-tit {
  height: 24px;
  line-height: 24px;
  padding: 8px 0;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 10px;
  }
}

.invite-login::v-deep {
  padding-top: 30px;

  .ant-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    .find-pwd-link {
      position: absolute;
      right: 12px;
      top: -5px;

      .js-code-bbt {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
      }
    }
  }
}
</style>
